<a
    class="flex flex-col items-center justify-center p-2 hover:bg-blurple rounded-lg"
    routerLink="/help"
    routerLinkActive="!bg-blurple-dark"
    (mouseenter)="isHovered = true"
    (mouseleave)="isHovered = false"
    pTooltip="Help and Resources"
    tooltipPosition="right"
    tooltipStyleClass="p-tooltip-fm-navigation"
    #link="routerLinkActive">
    <fa-icon
        class="text-[22px] text-white"
        [icon]="faCircleQuestion"
        [ngClass]="{ hidden: isHovered || link.isActive }" />
    <fa-icon
        class="text-[22px] text-white"
        [icon]="faCircleQuestionSolid"
        [ngClass]="{ hidden: !isHovered && !link.isActive }" />
</a>
